import deleteImg from '../../../../assets/img/admin/delete.svg'

import s from './AdminHeaderBlockElem.module.scss'

type AdminHeaderBlockElemProps = {
  index: number
  text: string
  onClick?: () => void
}

export const AdminHeaderBlockElem = ({ index, text, onClick }: AdminHeaderBlockElemProps) => {
  return (
    <div className={s.titleWrap}>
      <h6 className={s.title}>
        {text} №{index + 1}:
      </h6>

      {onClick && (
        <button className={s.deleteButton} onClick={onClick} title="Удалить элемент">
          <img src={deleteImg} alt="delete Img" />
        </button>
      )}
    </div>
  )
}
